<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            [style]="(`height: calc(100vh - ${offset}px)`)"
            id="gridMustDepartTimes"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [allowColumnReordering]="true"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="false"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'must-depart-times-grid-state', savingTimeout: 0 }"
            (onExporting)="onExporting($event)"
            (onRowUpdating)="onRowUpdating($event)"
            (onRowDblClick)="onRowDblClick($event)"
            (onInitNewRow)="onInitNewRow($event)"
            [customizeColumns]="customizeColumns"
            keyExpr="id"
            width="100%"
        >
            <dxo-editing
                [mode]="'row'"
                [allowUpdating]="canManage"
                [allowAdding]="canManage"
                [allowDeleting]="canManage"
                [useIcons]="true"
            >
            </dxo-editing>
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Must Depart Times</div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="auto" widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="auto" widget="dxButton" showText="inMenu"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto" showText="inMenu" widget="dxButton"
                    [options]="{ text: 'Reset', icon: 'restore', onClick: resetGrid, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item *ngIf="canManage" location="after" locateInMenu="never">
                    <dx-button class="ms-sm-2" text="New" icon="plus" type="default" stylingMode="contained" (onClick)="addNew()"></dx-button>
                </dxi-item>
            </dxo-toolbar>

            <dxi-column [dataField]="gridFieldName('city')" caption="City" dataType="string" [minWidth]="80">
                <dxi-validation-rule type="required" message="City is required"></dxi-validation-rule>
                <dxi-validation-rule type="stringLength" [max]="100" message="City cannot exceed 100 characters"></dxi-validation-rule>
            </dxi-column>

            <dxi-column [dataField]="gridFieldName('province')" caption="Province" [minWidth]="80"
                [lookup]="{ dataSource: provinceOptions, valueExpr: 'value', displayExpr: 'text' }"
                [headerFilter]="{ dataSource: provinceOptions }">
                <dxi-validation-rule type="required" message="Province is required"></dxi-validation-rule>
            </dxi-column>

            <dxi-column [dataField]="gridFieldName('country')" caption="Country" [minWidth]="60"
                [lookup]="{ dataSource: countryOptions, valueExpr: 'value', displayExpr: 'text' }"
                [headerFilter]="{ dataSource: countryOptions }">
                <dxi-validation-rule type="required" message="Country is required"></dxi-validation-rule>
            </dxi-column>

            <dxi-column [dataField]="gridFieldName('shipToTimeZone')" caption="Ship to Time Zone" cellTemplate="timeZone" [minWidth]="80"
                [lookup]="{ dataSource: timeZoneOptions, valueExpr: 'value', displayExpr: 'text' }"
                [headerFilter]="{ dataSource: timeZoneOptions }">
                <dxi-validation-rule type="required" message="Ship to Time Zone is required"></dxi-validation-rule>
            </dxi-column>

            <dxi-column [dataField]="gridFieldName('dropToHdcHours')" caption="Drop to HDC (h)" dataType="number" alignment="left" [minWidth]="60"
                [editorOptions]="{ min: 0, step: 1, format: '#0' }">
                <dxi-validation-rule type="required" message="Drop to HDC is required"></dxi-validation-rule>
                <dxi-validation-rule type="range" [min]="0" message="Must be 0 or greater"></dxi-validation-rule>
                <dxi-validation-rule type="custom" [validationCallback]="isWholeNumber" message="Must be a whole number"></dxi-validation-rule>
            </dxi-column>

            <dxi-column [dataField]="gridFieldName('mdtHopewell')" caption="MDT – Hopewell" dataType="string" cellTemplate="mdt" editCellTemplate="mdtEdit" [minWidth]="80">
            </dxi-column>

            <dxi-column [dataField]="gridFieldName('travelTimeHours')" caption="Travel Time (h)" dataType="number" alignment="left" [minWidth]="60"
                [editorOptions]="{ min: 0, step: 1, format: '#0' }">
                <dxi-validation-rule type="required" message="Travel Time is required"></dxi-validation-rule>
                <dxi-validation-rule type="range" [min]="0" message="Must be 0 or greater"></dxi-validation-rule>
                <dxi-validation-rule type="custom" [validationCallback]="isWholeNumber" message="Must be a whole number"></dxi-validation-rule>
            </dxi-column>

            <div *dxTemplate="let cellInfo of 'timeZone'">
                {{ timeZoneShort(cellInfo.value) }}
            </div>
            <div *dxTemplate="let cellInfo of 'mdt'">
                {{ getCellData(cellInfo).mdtHopewell | toDate | date: 'shortTime' }}
            </div>
            <div *dxTemplate="let cellInfo of 'mdtEdit'">
                <dx-date-box
                    type="time"
                    width="100%"
                    pickerType="list"
                    displayFormat="shortTime"
                    [showClearButton]="true"
                    [dateSerializationFormat]="'HH:mm'"
                    [value]="cellInfo.value"
                    (onValueChanged)="cellInfo.setValue($event.value)"
                ></dx-date-box>
            </div>
        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item [dataField]="filterModelName('city')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'City', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('province')" editorType="dxSelectBox" [editorOptions]="{ items: provinceOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Province', showClearButton: true, stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('shipToTimeZone')" editorType="dxSelectBox" [editorOptions]="{ items: timeZoneOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Ship to Time Zone', showClearButton: true, stylingMode: 'filled' }"></dxi-item>
        </dx-form>
    </filter-panel>
</div>
